import { render, staticRenderFns } from "./About_TermsOfUse.vue?vue&type=template&id=b594d73e&scoped=true"
import script from "./About_TermsOfUse.vue?vue&type=script&lang=js"
export * from "./About_TermsOfUse.vue?vue&type=script&lang=js"
import style0 from "./About_TermsOfUse.vue?vue&type=style&index=0&id=b594d73e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b594d73e",
  null
  
)

export default component.exports